import { useActiveAlarms } from "../../hooks/useActiveAlarms";
import {  COLOR, PLACEMENT, Badge } from 'baseui/badge';
import { NavigationButton } from "../../components/NavigationButton/NavigationButton";
import { Delayed } from "../../components/Delayed";
import { IoNotificationsOutline } from "react-icons/io5";

export const AlarmNavigationButton = (props: any) => {
    return (
        <NavigationButton href='/alarms' title='Alarms' >
            <Delayed waitBeforeShow={3000} alternativeChildren={<IoNotificationsOutline size='1.2em'></IoNotificationsOutline>}>
                <AlarmBadge />
            </Delayed>
        </NavigationButton>)
}

const AlarmBadge = () => {

    const { count: activeAlarmsCount } = useActiveAlarms()
    //const { count: notAckedAlarmsCnt } = useNotAckedAlarms()
    //const hasNotAckedAlarms = notAckedAlarmsCnt > 0;
    const hasAlarms = activeAlarmsCount > 0;
    const horizontalOffset = activeAlarmsCount > 9 ? "-20px" : "-15px";
    return (
        <>
            {hasAlarms ?
                (
                        <Badge shape='pill'
                            content={activeAlarmsCount}
                            color={COLOR.negative}
                            placement={PLACEMENT.topRight}
                            horizontalOffset={horizontalOffset}
                            verticalOffset="-15px"
                            overrides={{
                                Badge: {
                                  style: ({ $theme }) => ({
                                    fontWeight: "normal"
                                  })
                                }
                              }}
                        >
                            <IoNotificationsOutline size='1.2em'></IoNotificationsOutline>
                        </Badge>
                )
                :
                (
                    <IoNotificationsOutline size='1.2em'></IoNotificationsOutline>
                )
            }
        </>
    )

}

/*
  return (
        <>
            {hasNotAckedAlarms ?
                (<NotificationCircle
                    content={notAckedAlarmsCnt}
                    color={COLOR.negative}
                    placement={PLACEMENT.topRight}
                    horizontalOffset="-15px"
                    verticalOffset="-15px"
                >
                    <IoNotificationsOutline size='1.2em'></IoNotificationsOutline>
                </NotificationCircle>)
                :
                hasAlarms ?
                    (
                        <NotificationCircle
                            content={activeAlarmsCount}
                            color={COLOR.primary}
                            placement={PLACEMENT.topRight}
                            horizontalOffset="-15px"
                            verticalOffset="-15px"
                        >
                            <IoNotificationsOutline size='1.2em'></IoNotificationsOutline>
                        </NotificationCircle>
                    )
                    :
                    (
                        <IoNotificationsOutline size='1.2em'></IoNotificationsOutline>
                    )
            }
        </>
    )
    */